/**
 * Safari 12 has no `100dvh`, and iOS Safari's `100vh` famously includes the browser chrome, so a
 * full-bleed slideshow measured in `vh` gets clipped. Everything sizes off `--vh` instead.
 */
export function installViewportUnit(): () => void {
  const apply = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
  };

  apply();
  window.addEventListener('resize', apply);
  window.addEventListener('orientationchange', apply);
  // iOS updates innerHeight only after the rotation animation settles.
  window.addEventListener('orientationchange', () => setTimeout(apply, 350));

  return () => {
    window.removeEventListener('resize', apply);
    window.removeEventListener('orientationchange', apply);
  };
}
